<template>
  <div class="amenity">
    <vb-icon class="amenity__icon" :name="amenity(item).icon" :color="sass('gray-600')" :size="14" />
    <span class="amenity__text">{{ amenity(item).label }}</span>
  </div>
</template>

<script>
import { get_amenities_property, get_amenities_rooms, get_amenities_rates, get_amenities_flags } from '@liveeps/resources'

export default {
  name: 'amenity',

  components: {
  },

  props: {
    item: String,
    type: String,
  },

  data() {
    return {
    }
  },

  computed: {
    amenity() {
      const map = {
        property: get_amenities_property,
        rooms: get_amenities_rooms,
        rates: get_amenities_rates,
        flags: get_amenities_flags,
      }
      return map[this.type]
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .amenity {
    display: flex;
    align-items: center;
    line-height: normal;
    font-size: $font-size-md;

    &__icon {
      margin-top: 2px;
      margin-right: $grid-gutter-width / 6;
    }
  }

</style>